import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Button, H5, Modal } from '../../../../../components';
import { DayPicker, MonthPicker, PeriodPicker, ShareModalHeader } from '../../molecules';
import { PickerInput } from '../../atoms';

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-bottom: 20px;
`;

const RecurrenceContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

const StyledButton = styled(Button)`
  margin-top: 20px;
  border-radius: 22px;
  flex: 1;
`;

const StyledShareModalHeader = styled(ShareModalHeader)`
  padding: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  column-gap: 10px;
`;

const StyledH5 = styled(H5)`
  margin-bottom: 10px;
`;

const CustomScheduleModal = ({ onSubmitConversationSchedule }) => {
  const [period, setPeriod] = useState('Week');
  const [weekDay, setWeekDay] = useState(1);
  const [monthDay, setMonthDay] = useState(1);
  const [frequency, setFrequency] = useState(1);

  const generateCronSchedule = () => {
    switch (period) {
      case 'Day':
        return `0 7 */${frequency} * *`;
      case 'Week':
        return `0 7 * * ${weekDay}/${frequency}`;
      case 'Month':
        return `0 7 ${monthDay} */${frequency} *`;
      default:
        return null;
    }
  };

  const handleOnSubmit = (close) => {
    onSubmitConversationSchedule({
      cronSchedule: generateCronSchedule(),
      timezone: 'America/New_York',
      isActive: true
    });
    close();
  };

  const renderPickerBasedOnPeriod = (_period) => {
    switch (_period) {
      case 'Week':
        return (
          <>
            <StyledH5>On every</StyledH5>
            <StyledContainer>
              <DayPicker weekDay={weekDay} setWeekDay={setWeekDay} />
            </StyledContainer>
          </>
        );
      case 'Month':
        return <MonthPicker setMonthDay={setMonthDay} />;
      default:
        return null;
    }
  };
  return (
    <Modal size='sm' bodyStyle={{ padding: 20 }}>
      {(close) => (
        <>
          <StyledShareModalHeader title='Set refresh schedule' onClose={close} />
          <RecurrenceContainer>
            <StyledH5>Refresh every</StyledH5>
            <StyledContainer>
              <PickerInput setFrequency={setFrequency} />
              -
              <PeriodPicker period={period} setPeriod={setPeriod} />
            </StyledContainer>
            {renderPickerBasedOnPeriod(period)}
          </RecurrenceContainer>
          <ButtonContainer>
            <StyledButton naked onClick={() => close()} block>
              Cancel
            </StyledButton>
            <StyledButton primary onClick={() => handleOnSubmit(close)} block>
              Save
            </StyledButton>
          </ButtonContainer>
        </>
      )}
    </Modal>
  );
};

CustomScheduleModal.propTypes = {
  onSubmitConversationSchedule: PropTypes.func.isRequired
};

export { CustomScheduleModal };
